<template>
  <v-container fluid grid-list-lg>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="false"
        title="Transaction"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="Transactions"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.createdAt | moment("LL LT") }}</td>
            <td class="text-left">{{ item.transactionId }}</td>
            <td class="text-left"><span v-if="item.Invoice">{{ item.Invoice.localId }}</span></td>
            <td class="text-left">{{ item.type }}</td>
            <td class="text-left">{{ item.status }}</td>
            <td class="text-center">{{ item.amount | currency}}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import TransactionService from "../service";
import { mapGetters } from "vuex";

export default {
  name: "Transaction-list",
  data() {
    return {
      headers: [
        {
          text: 'Created At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Id",
          align: "left",
          value: "transactionId",
          sortable: true,
        },
        {
          text: "Invoice Id",
          align: "left",
          value: "Invoice.localId",
          sortable: true,
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          sortable: true,
        },
        {
          text: "Status",
          align: "left",
          value: "status",
          sortable: true,
        },
        {
          text: "Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
      ],
      Transactions: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "amount",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Transaction List";
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    getList() {
      this.loading = true;
      return TransactionService.getAll({includeInvoice: true}).then((response) => {
        console.log('response', response)
        this.loading = false;
        this.Transactions = response.data;
        return response;
      });
    },
  },
};
</script>
